import { updateUserMemory, useUserMemory } from 'api/goodtrust/user/memory'
import { SIconEdit, SMemoryTitle, STitleSpinner } from './MemoryTitle.styled'

import { SubtleInput } from 'components/subtleInput/SubtleInput'
import { handleAndToastError } from 'components/Toast'
import { useRef } from 'react'
import { unwrapResponse } from 'utils/fetcher'
import { useLoadingCallback } from 'utils/hooks'

export default function MemoryTitle({
  memoryUuid,
  className,
}: {
  memoryUuid?: string
  className?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const memory = useUserMemory(memoryUuid)
  const name = memory.data?.json?.name || memory.data?.json?.original_file?.name
  const [onSubmit, isSubmitting] = useLoadingCallback(async (newName?: string) => {
    if (memoryUuid && newName && newName.length && newName !== name) {
      try {
        await updateUserMemory(memoryUuid, { name: newName }).then(unwrapResponse)
        await memory.mutate()
      } catch (err) {
        handleAndToastError(err, 'failed_to_rename_memory')
      }
    }
  })
  const isEditing = ref.current?.contains(document.activeElement)
  return memory.data?.json ? (
    <SMemoryTitle className={className} ref={ref}>
      {isSubmitting ? (
        <STitleSpinner />
      ) : (
        <>
          <SubtleInput value={name} onSubmit={onSubmit} />
          <SIconEdit name="DocumentEdit" color="white" size="1.75rem" hide={isEditing} />
        </>
      )}
    </SMemoryTitle>
  ) : null
}
